export const FEATURE_KEYS = {
  MENU_PEDIDOS_ENABLED: "MENU_PEDIDOS_ENABLED",
};

// Default opt-out: ausente (false/undefined/null) => true; solo "false" oculta.
export function isFeatureEnabledValue(raw) {
  if (raw === false || raw === undefined || raw === null) return true;
  return String(raw).toLowerCase() !== "false";
}
